"use client";

import Image from "next/image";

import {
  Modal,
  ModalBody,
  ModalHeader,
  Typography,
} from "@artha/ui";

type IncognitoRestrictionModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const IncognitoRestrictionModal = ({
  isOpen,
}: IncognitoRestrictionModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      className="mx-0 border border-black p-6 !animate-none"
    >
      <ModalHeader>
        <Image
          src="/images/rejection-illustration.png"
          alt=""
          width={80}
          height={80}
          className="mb-4 object-contain"
        />
        <Typography
          variant="lead"
          className="text-center text-lg font-semibold leading-relaxed text-[#344054]"
        >
          Private Browsing Detected
        </Typography>
      </ModalHeader>

      <ModalBody>
        <Typography
          variant="small"
          className="text-sm leading-relaxed text-[#667085] text-center"
        >
          We do not allow access to the platform or job applications while using private or incognito browsing mode. Please open a normal tab to continue.
        </Typography>
      </ModalBody>
    </Modal>
  );
};
